module.exports = __webpack_public_path__ + "static/media/skyline.5bb444e8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/skyline.jpg
// module id = 241
// module chunks = 0